(function () {
  var INIT_DONE = false;
  var COLOR_OPTION_FALLBACK = 'Color';
  var LS_KEY = 'cmb_season';
  var LS_DISABLE_KEY = 'cmb_season_disabled';

  // --- helpers ---
  function getBar() { return document.querySelector('.cmb-season-bar'); }

  function getOptionName() {
    var bar = getBar();
    var name = bar && bar.dataset.colorOption;
    return (name && name.trim()) ? name.trim() : COLOR_OPTION_FALLBACK;
  }

  // Precedence: URL ?season= > localStorage cmb_season > default '__all'
  function resolveSeason() {
    try {
      var params = new URLSearchParams(location.search);
      var fromUrl = params.get('season');
      if (fromUrl) return fromUrl;
    } catch (e) {}
    try {
      var fromLS = localStorage.getItem(LS_KEY);
      if (fromLS) return fromLS;
    } catch (e) {}
    return '__all';
  }

  function writeSeason(val) {
    // Update URL
    try {
      var p = new URLSearchParams(location.search);
      if (val === '__all') { p.delete('season'); } else { p.set('season', val); }
      history.replaceState({}, '', location.pathname + (p.toString() ? '?' + p.toString() : ''));
    } catch (e) {}
    // Update localStorage
    try {
      if (val === '__all') {
        localStorage.removeItem(LS_KEY);
      } else {
        localStorage.setItem(LS_KEY, val);
      }
    } catch (e) {}
  }

  // Get ALL shade labels for this product page, but skip Quick View / modal duplicates
  function getShadeLabels() {
    var all = Array.from(document.querySelectorAll('label.color-watches[data-name="' + getOptionName() + '"]'));
    return all.filter(function (l) {
      if (!l.id) return true;
      if (l.id.startsWith('sections--')) return false;
      if (l.closest('#quick-view, [id*="__quick-view"]')) return false;
      return true;
    });
  }

  function inputForLabel(label) {
    var id = label.getAttribute('for');
    return id ? document.getElementById(id) : null;
  }

  function setButtonsState(season) {
    var bar = getBar();
    if (!bar) return;
    bar.querySelectorAll('.cmb-season-btn').forEach(function (btn) {
      var s = btn.dataset.season || '__all';
      btn.setAttribute('aria-pressed', s === season ? 'true' : 'false');
    });
  }

  function applySeasonFilter(season) {
    var labels = getShadeLabels();

    labels.forEach(function (label) {
      var seasonsAttr = (label.getAttribute('data-seasons') || '')
        .split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      var match = (season === '__all' || !season) || seasonsAttr.includes(season);
      label.classList.toggle('cmb-swatch-muted', !match);
      label.setAttribute('aria-disabled', match ? 'false' : 'true');
    });

    // If the selected shade got muted, auto-select the first allowed one
    var selected = document.querySelector('input[name="' + getOptionName() + '"]:checked');
    if (selected) {
      var selLabel = document.querySelector('label[for="' + selected.id + '"]');
      if (selLabel && selLabel.classList.contains('cmb-swatch-muted')) {
        var firstOK = labels.find(function (l) { return !l.classList.contains('cmb-swatch-muted'); });
        if (firstOK) {
          var input = inputForLabel(firstOK);
          if (input) input.click();
        }
      }
    }
  }

  function bindBar() {
    var bar = getBar();
    if (!bar) return;
    bar.addEventListener('click', function (e) {
      var a = e.target.closest('.cmb-season-btn');
      if (!a) return;
      e.preventDefault();

      var val = a.dataset.season || '__all';
      writeSeason(val);
      setButtonsState(val);
      applySeasonFilter(val);
    });
  }

  function init() {
    if (INIT_DONE) return;
    INIT_DONE = true;

    // Debug off-switch: if either flag is set, do nothing (shade picker falls back to showing all shades).
    //   localStorage.cmb_season_disabled === 'true'  → skip persistence for this user
    //   ?season_override=all in URL                   → one-shot QA override
    try {
      if (localStorage.getItem(LS_DISABLE_KEY) === 'true' ||
          new URLSearchParams(window.location.search).get('season_override') === 'all') {
        return;
      }
    } catch (e) {}

    var season = resolveSeason();
    setButtonsState(season);
    bindBar();
    applySeasonFilter(season);

    // Keep filter in sync when the shade variant changes (Eurus may clobber the URL;
    // resolveSeason() falls back to localStorage so state survives variant clicks).
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[name="' + getOptionName() + '"]')) {
        applySeasonFilter(resolveSeason());
      }
    });
  }

  // Expose for console testing even before init
  window.cmbApplySeasonFilter = function (s) { applySeasonFilter(s || '__all'); };

  // Run now if DOM is already ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-run when sections reload
  document.addEventListener('shopify:section:load', function () {
    INIT_DONE = false;
    init();
  });
})();
